module.exports = __webpack_public_path__ + "static/media/image1.b2899832.jpg";